import type { Theme } from "../tokens";

/** A terminal that happens to be legible. Maximum messages per screen. */
export const ledger: Theme = {
  id: "ledger",
  name: "Ledger",
  thesis: "A terminal that happens to be legible. Maximum messages per screen.",
  scheme: "light",
  colors: {
    ground: "#EDEEF0",
    surface: "#FFFFFF",
    raised: "#F3F5F8",
    ink: "#16181C",
    // Art measured #6E7480 at 4.04 on this theme's grey ground and mitigated it
    // with a rule: "list rows are always white, never grounded". Darkened to
    // #636974 (4.76 on ground, 5.52 on surface) so the rule is unnecessary --
    // a palette that is safe everywhere beats one that is safe if you remember.
    dim: "#636974",
    rule: "#D3D7DE",
    lattice: "#E4E7EC",
    focus: "#0F62FE",
    inbox: "#0F62FE",
    feed: "#5E6470",
    paperTrail: "#767C88",
    screener: "#B25C00",
  },
  type: {
    sans: "'IBM Plex Sans Condensed', system-ui, sans-serif",
    mono: "'IBM Plex Mono', ui-monospace, monospace",
    googleFonts: "IBM+Plex+Sans+Condensed:wght@400;600&family=IBM+Plex+Mono:wght@400;600",
    tracking: "0",
  },
  density: {
    row: 28,
    primary: 13,
    secondary: 13,
    meta: 12,
    listWidth: 0,
    rail: 188,
    radius: 0,
    lineHeight: 1.3,
  },
  markers: {
    inbox: "●",
    feed: "◆",
    paperTrail: "▭",
    screener: "▲",
  },
};
